export const INTENTS_RESOLVER_INTEROP_PREFIX = "T42.Intents.Resolver.Control.";

export const INTENTS_RESOLVER_WIDTH = 400;

export const INTENTS_RESOLVER_HEIGHT = 440;

export const DEFAULT_METHOD_RESPONSE_TIMEOUT_MS = 60000;

export const DEFAULT_RAISE_TIMEOUT_MS = 90000;
